import { headerBgGradientCode } from './HeaderBgStore';

export const updateHeaderBgGradientCode = (value) => headerBgGradientCode.update(oldValue => value);
